import { FileValidationResult, FileUploadConfig } from "./types";

const isProduction = process.env.NODE_ENV !== "development";
// const isProduction = true;
const PROTOCOL = isProduction ? window.location.protocol : "http:";
const HOST_NAME = isProduction ? window.location.host : "localhost:18081";
const MAIN_URL = `${PROTOCOL}//${HOST_NAME}`;

export const DEFAULT_CONFIG: FileUploadConfig = {
  maxFileSize: 10 * 1024 * 1024, // 10MB
  maxTotalSize: 50 * 1024 * 1024, // 50MB
  acceptedFileTypes: "*/*",
  uploadUrl: `${MAIN_URL}/api/updown-files/upload`,
  downloadUrl: `${MAIN_URL}/api/updown-files/download`,
  deleteUrl: `${MAIN_URL}/api/updown-files/delete`,
  webdavAddress: `${MAIN_URL}/api/updown-files/webdav-address`
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const getFileTypeIcon = (fileType: string): string => {
  if (fileType.startsWith("image/")) return "🖼️";
  if (fileType === "application/pdf") return "📄";
  if (fileType.includes("word")) return "📝";
  if (fileType.includes("excel") || fileType.includes("sheet")) return "📊";
  return "📎";
};

export const validateFiles = (
  files: FileList,
  config: FileUploadConfig = DEFAULT_CONFIG
): FileValidationResult => {
  const validFiles: File[] = [];
  const errors: string[] = [];
  let totalSize = 0;

  Array.from(files).forEach(file => {
    // 개별 파일 크기 검증
    if (file.size > config.maxFileSize) {
      errors.push(
        `${file.name}: 파일 크기가 ${formatFileSize(
          config.maxFileSize
        )}를 초과합니다.`
      );
      return;
    }
    validFiles.push(file);
    totalSize += file.size;
  });

  // 전체 파일 크기 검증
  if (totalSize > config.maxTotalSize) {
    errors.push(
      `전체 파일 크기가 ${formatFileSize(config.maxTotalSize)}를 초과합니다.`
    );
    return { validFiles: [], errors };
  }

  return { validFiles, errors };
};

export const mergeFileList = (
  existingFiles: FileList | null,
  newFiles: File[]
): FileList => {
  const dataTransfer = new DataTransfer();

  if (existingFiles) {
    Array.from(existingFiles).forEach(file => dataTransfer.items.add(file));
  }

  newFiles.forEach(file => dataTransfer.items.add(file));

  return dataTransfer.files;
};

export const removeFileFromList = (
  files: FileList,
  indexToRemove: number
): FileList => {
  const filesArray = Array.from(files);
  filesArray.splice(indexToRemove, 1);

  const dataTransfer = new DataTransfer();
  filesArray.forEach(file => dataTransfer.items.add(file));

  return dataTransfer.files;
};

export const getTotalFileSize = (files: FileList | null): string => {
  if (!files) return "0 Bytes";
  const totalBytes = Array.from(files).reduce(
    (total, file) => total + file.size,
    0
  );
  return formatFileSize(totalBytes);
};
